import ko from "knockout";
import moment from 'moment';
import { CustomError, customFetch as fetch } from "../../../fetch";
import SelectListItemModel from "../../../custom/selectlist-item-model";
import { errorToast } from "../../../toastr-helper";

export default class GeneralInfo {
    parent: any;
    saving: KnockoutObservable<boolean>;
    validationErrors: KnockoutObservableArray<CustomError>;
    shouldDisableFields: KnockoutObservable<boolean>;
    
    companyName: KnockoutObservable<string>;
    postalCode: KnockoutObservable<string>;
    houseNumber: KnockoutObservable<string>;
    address: KnockoutObservable<string>;
    city: KnockoutObservable<string>;
    kvkNumber: KnockoutObservable<string>;
    startDate: KnockoutObservable<moment.Moment>;
    firstPayDate: KnockoutObservable<moment.Moment>;

    hasCashout: KnockoutObservable<boolean>;
    modulesEnabled: KnockoutObservable<boolean>;
    creditCheckDone: KnockoutObservable<boolean>;

    weeklyPay: KnockoutObservable<boolean>;
    fourWeeklyPay: KnockoutObservable<boolean>;
    monthlyPay: KnockoutObservable<boolean>;

    constructor(model: any, parent: any) {
        this.parent = parent;
        this.saving = ko.observable<boolean>(false);
        this.validationErrors = ko.observableArray<CustomError>();
        this.shouldDisableFields = ko.pureComputed(() => this.parent.onboardingStatus() !== 1);
        
        this.companyName = ko.observable<string>(model.name).extend({
            errorHandler: { source: this.validationErrors, id: 'CompanyName' }
        });
        this.postalCode = ko.observable<string>(model.postal_code).extend({
            errorHandler: { source: this.validationErrors, id: 'PostalCode' }
        });
        this.houseNumber = ko.observable<string>(model.house_number).extend({
            errorHandler: { source: this.validationErrors, id: 'HouseNumber' }
        });
        this.address = ko.observable<string>(model.address).extend({
            errorHandler: { source: this.validationErrors, id: 'Address' }
        });
        this.city = ko.observable<string>(model.city).extend({
            errorHandler: { source: this.validationErrors, id: 'City' }
        });
        this.kvkNumber = ko.observable<string>(model.kvk_number).extend({
            errorHandler: { source: this.validationErrors, id: 'KvkNumber' }
        });
        this.startDate = ko.observable<moment.Moment>(model.start_date ? moment(model.start_date) : null).extend({
            errorHandler: { source: this.validationErrors, id: 'StartDate' }
        });
        this.firstPayDate = ko.observable<moment.Moment>(model.first_pay_date ? moment(model.first_pay_date) : null).extend({
            errorHandler: { source: this.validationErrors, id: 'FirstPayDate' }
        });
        
        this.hasCashout = ko.observable<boolean>(model.has_cashout);
        this.modulesEnabled = ko.observable<boolean>(model.modules_enabled).extend({
            errorHandler: { source: this.validationErrors, id: 'ModulesEnabled' }
        });
        this.creditCheckDone = ko.observable<boolean>(model.credit_check_done).extend({
            errorHandler: { source: this.validationErrors, id: 'CreditCheckDone' }
        });

        this.weeklyPay = ko.observable<boolean>(model.weekly_pay);
        this.fourWeeklyPay = ko.observable<boolean>(model.four_weekly_pay);
        this.monthlyPay = ko.observable<boolean>(model.monthly_pay);


        this.monthlyPay.subscribe((newValue) => {
            if (newValue) {
                this.weeklyPay(false);
                this.fourWeeklyPay(false);
            }
        });

        this.weeklyPay.subscribe((newValue) => {
            if (newValue) this.monthlyPay(false);
        });

        this.fourWeeklyPay.subscribe((newValue) => {
            if (newValue) this.monthlyPay(false);
        });
    }

    
    async submit(){
        this.saving(true);
        this.parent.submit();
        this.saving(false);
    }

    toJson() {
        return {
            name: this.companyName(),
            postal_code: this.postalCode(),
            house_number: this.houseNumber(),
            address: this.address(),
            city: this.city(),
            startDate: this.startDate(),
            kvk_number: this.kvkNumber(),
            start_date: this.startDate() ? this.startDate().toISOString() : null,
            first_pay_date: this.firstPayDate() ? this.firstPayDate().toISOString() : null,
            has_cashout: this.hasCashout(),
            modules_enabled: this.modulesEnabled(),
            credit_check_done: this.creditCheckDone(),
            weekly_pay: this.weeklyPay(),
            four_weekly_pay: this.fourWeeklyPay(),
            monthly_pay: this.monthlyPay()
        };
    }

    async validateModel() {
        if(!this.weeklyPay() && !this.fourWeeklyPay() && !this.monthlyPay()) {
            errorToast("Type verloning moet nog worden in gevuld onder het tabje algemeen")
        }
        
        const url = '/admin/CompanyOnboarding/ValidateGeneralInfoModel';

        const body= this.toJson();

        const response = await fetch(url, {
            headers: {
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            this.parent.validationIsSuccessful = false;
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }
    }
}
